import React from "react";
import { Eye, X } from "lucide-react";

interface BatchSummaryModalProps {
    isOpen: boolean;
    modalData: any;
    onClose: () => void;
}

const BatchSummaryModal: React.FC<BatchSummaryModalProps> = ({
    isOpen,
    modalData,
    onClose,
}) => {
    if (!isOpen || !modalData) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm animate-fadeIn">
            <div className="bg-white rounded-2xl max-w-lg w-full p-6 shadow-xl relative max-h-[85vh] overflow-y-auto">
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
                >
                    <X className="w-5 h-5" />
                </button>

                <div className="flex items-center gap-2 mb-6 text-purple-600 border-b pb-3">
                    <Eye className="w-5 h-5" />
                    <h2 className="text-xl font-bold text-gray-900">
                        Batch Summary Details
                    </h2>
                </div>

                <div className="space-y-4">
                    {modalData.fileName && (
                        <div>
                            <label className="text-xs font-bold uppercase tracking-wider text-gray-400">
                                File Name
                            </label>
                            <p className="text-sm font-semibold text-gray-800 break-all">
                                {modalData.fileName}
                            </p>
                        </div>
                    )}

                    <div className="bg-gray-50 border border-gray-100 rounded-xl p-4 divide-y divide-gray-200/60 text-sm">
                        {Object.entries(modalData).map(([key, value]) => {
                            if (
                                typeof value === "object" &&
                                value !== null
                            ) {
                                return null;
                            }

                            return (
                                <div
                                    key={key}
                                    className="flex justify-between items-start py-2.5 gap-4"
                                >
                                    <span className="text-gray-500 font-medium capitalize shrink-0">
                                        {key
                                            .replace(/([A-Z])/g, " $1")
                                            .trim()}
                                    </span>

                                    <span className="text-gray-900 font-semibold break-all text-right">
                                        {typeof value === "boolean"
                                            ? String(value)
                                            : String(value)}
                                    </span>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BatchSummaryModal;